import { Button, Group } from '@mantine/core'
import { notifications } from '@mantine/notifications'

export function notifyError(error: unknown): void {
  notifications.show({ color: 'red', message: error instanceof Error ? error.message : String(error) })
}

export function notifySaved(message: string): void {
  notifications.show({ color: 'teal', message })
}

/**
 * The M3 snackbar with one action (§11.3): stays on screen until acted on or dismissed, rather than timing out, so
 * an Undo is never missed. The id is generated up front so the Undo button can close its own toast.
 */
export function notifyUndo(message: string, onUndo: () => void): void {
  const id = crypto.randomUUID()
  notifications.show({
    id,
    autoClose: false,
    message: (
      <Group justify="space-between" wrap="nowrap" gap="md">
        <span>{message}</span>
        <Button
          variant="subtle"
          size="compact-sm"
          c="var(--md-sys-color-inverse-primary)"
          onClick={() => {
            onUndo()
            notifications.hide(id)
          }}
        >
          Undo
        </Button>
      </Group>
    ),
  })
}
